import type { FC } from "react";
import { assert } from "@/helpers/console.ts";
import { styled } from "@linaria/react";
import { RenderLatex } from "@/helpers/latex.tsx";
import type { FlowItem } from "@/types/flow.ts";

const Name = styled.h3`
  font-weight: 600;
  margin-bottom: 0.5rem;
`;

interface FlowMessageTextProps {
  name?: string | null;
  message: string;
  flowItem?: Partial<FlowItem>;
}

/**
 *
 * @remarks Parent container should have a flex display so the right-sided messages can use flex-end
 */
export const FlowMessageText: FC<FlowMessageTextProps> = ({ name, message, flowItem }) => {
  assert(message.length !== 0, "Message length needs to be more than 0");
  assert(name?.length !== 0, "Name length needs to be more than 0");

  return (
    <>
      {name && <Name>{name}</Name>}
      <RenderLatex message={message} flowItem={flowItem} />
    </>
  );
};
